export default "__VITE_ASSET__CF3TFEWX__"